import todoReducer from "./todoReducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    todoReducer
})

export default rootReducer;